import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { GlobalVariables } from 'app/services/globals';

export const vivaInsightsReportMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.vivaInsights.datasetType,
    displayName: stringResources.VivaInsights_DisplayText,
    supportLinkedServiceTypes: [adfModelTypeMap.vivaInsights.linkedServiceType],
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-VivaInsights'
    },
    isFirstClass: true,
    isSource: true,
    isSink: false,
    category: ['ServicesApps'],
    disabled: !GlobalVariables.enableVivaInsightsConnector,
    isTableRequired: true,
    tableNameDisplay: stringResources.ModelName_Report,
    tableNamePlural: stringResources.ModelName_Reports,
    supportCreatedAsV2: true,
    // A report is pre-computed server-side; there is no query API to push a predicate into.
    notSupportCopySourceQuery: true,
    notSupportLookupActivity: true,
    // The schema is discovered per report at run time, so there is no stable physical type to report.
    notSupportPhysicalType: true,
    controls: [
        {
            type: 'table-selection',
            bind: 'tableName',
            label: stringResources.ModelName_Report,
            required: true,
            refreshTableAfterInitialization: true,
            showPreviewButton: true,
            parameterizable: true
        }
    ],
    copyJob: {
        // An app-only identity cannot enumerate the report catalog, so it needs to name a report id directly.
        manualTableInput: true
    }
};
